var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_5592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0107 13.4721C3.1707 13.4721 3.2027 13.4561 3.3467 13.4241L6.2267 12.8481C6.5307 12.7681 6.8347 12.6241 7.0747 12.3841L14.0507 5.40809C15.1227 4.33609 15.1227 2.49609 14.0507 1.42409L13.4587 0.800094C12.3867 -0.271906 10.5307 -0.271906 9.45869 0.800094L2.4827 7.79209C2.2587 8.01609 2.0987 8.33609 2.0187 8.64009L1.4107 11.5521C1.3307 12.0961 1.4907 12.6241 1.8747 13.0081C2.1787 13.3121 2.6267 13.4721 3.0107 13.4721ZM3.5547 8.94409L10.5307 1.95209C10.9947 1.48809 11.8427 1.48809 12.2907 1.95209L12.8987 2.56009C13.4427 3.10409 13.4427 3.87209 12.8987 4.40009L5.9387 11.3921L2.9787 11.8881L3.5547 8.94409Z",
    fill: "#FFA425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9862 14.4639H2.17816C1.71416 14.4639 1.41016 14.7679 1.41016 15.2319C1.41016 15.6959 1.79416 15.9999 2.17816 15.9999H13.9222C14.3862 15.9999 14.7702 15.6959 14.7702 15.2319C14.7542 14.7679 14.3702 14.4639 13.9862 14.4639Z",
    fill: "#FFA425"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_5592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.128906)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3beabb3dc4e2317dd3e8a9ff8cbf2957.svg";
export { ForwardRef as ReactComponent };